export const calculateTotalPrice = (lstProduct) => {
  return lstProduct.reduce((total, pItem) => {
    return total + pItem.price_after * pItem.quantity;
  }, 0);
};
